/** @fileoverview list_search_analytics_views の共通定数 */

/** ツール名（単一参照点） */
export const LIST_SEARCH_ANALYTICS_VIEWS_NAME =
  "list_search_analytics_views" as const;

/** LLM へ提示する説明文 */
export const LIST_SEARCH_ANALYTICS_VIEWS_DESC = `Lists Search Analytics views for a project.

Use when a user asks to list or choose Search Analytics views for a given project and to understand each view's saved conditions (filters, group-by for raw data) along with the view's default period.

Input:
- 'projectId' (required): ID of the Search Analytics project.

Notes:
- Read-only; does not create, update, or delete anything.
- Returns: { searchAnalyticsId, views: [{ id, name, description, dataDate, rawDataGroupBy, isAnonymousQuery, countries, devices, searchTypes, queryFilterType, query, queryGroupIDs, urlFilterType, url, urlGroupIDs, rawKinds, rawKindsNot }] }.
- 'dataDate' includes { type, dateRange { start, end } } which represents the view's saved default period.`;
